import { useMemo } from "react";
import { ManualBillActivity } from "../../../api/services";
import { formatMoneyWithSign } from "../../../utils/formatMoney";

export const useManualBillActivity = (activity: ManualBillActivity) => {
  const { currency, amount } = activity;
  return useMemo(() => {
    return {
      title: `Manual Bill: ${formatMoneyWithSign(currency, amount)}`,
    };
  }, [currency, amount]);
};
